import {useThree } from "@react-three/fiber";
import * as THREE from 'three';
import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";

export const RoomModel = () => {
  const obj = useGLTF('/3d/village/scene.gltf');

  return (
    <primitive scale={[1, 1, 1]} position={[-4,0,-10]} object={obj.scene} />
  )
}

export const SkyBox = () => {
  const {scene, invalidate} = useThree();
  const loader = new THREE.TextureLoader();
  // The CubeTextureLoader load method takes an array of urls representing all 6 sides of the cube.
  const texture = loader.load(
    '/3d/sky.png',
    () => {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      texture.rotation = 1.5;
      texture.colorSpace = THREE.SRGBColorSpace;
      scene.background = texture;
    });

  useEffect(() => {
    console.log("inval playerslength");
    
    invalidate();
  }, []);

  return null;
}